import { CellProps, Column } from "react-table"

import { Client } from "models/common"
import { ColorMap } from "utils/color"
import { Link } from "components/Link"
import { Status } from "components/Status"
import { useI18n } from "providers/I18n"

export const columns = (): Array<
  Column<Client> & {
    header: string
    fixed?: boolean
    default: boolean
    variant?: string
    sortable?: boolean
  }
> => [
  {
    fixed: true,
    default: true,
    sortable: false,
    header: "clients.list.name",
    id: "name",
    accessor: "name",
    Cell: function (props: CellProps<Client>) {
      const { id, name } = props.row.original

      return (
        <Link color="primary" to={`/market-clients/${id}/profile`}>
          {name}
        </Link>
      )
    },
  },
  {
    default: true,
    sortable: false,
    header: "clients.list.status",
    id: "status",
    accessor: "status",
    Cell: function (props: CellProps<Client>) {
      const { value: status } = props
      const { t } = useI18n()
      return status === null ? null : (
        <Status color={ColorMap[status]}>{t(`status.${status ?? ""}`)}</Status>
      )
    },
  },
  {
    default: true,
    sortable: false,
    header: "clients.list.companies",
    id: "companies",
    Cell: function (props: CellProps<Client>) {
      const { companies } = props.row.original
      return (companies || [])?.map((c, cidx) => (
        <div key={cidx}>{`${c?.name} - ${c?.clientCode}`}</div>
      ))
    },
  },
  {
    default: true,
    sortable: false,
    header: "clients.list.ipgCompany",
    id: "companyIpg",
    Cell: function (props: CellProps<Client>) {
      const { intercompany } = props.row.original
      return <div>{intercompany?.name}</div>
    },
  },
  {
    default: true,
    sortable: false,
    header: "clients.list.client-groups",
    id: "groupName",
    accessor: "groupName",
  },
]

export const filters = []
export const sortByDefault = "name,ASC"
